export const NAVIGATION_LIST = [
  { name: 'Dashboard', icon: 'icon-house', href: '/dashboard', displayCount: false, totalItemsCount: 0 },
  { name: 'Referrals', icon: 'icon-contacts', href: '/referrals', displayCount: false, totalItemsCount: 0 },
  { name: 'Appointments', icon: 'icon-calendar', href: '/appointments', displayCount: false, totalItemsCount: 0 },
  { name: 'Tasks', icon: 'icon-tasks', href: '/tasks', displayCount: false, totalItemsCount: 0 }
];

export const INITIAL_APP_STATE = {
  appointments: {
    isDateView: true
  },
  header: {
    isLoadingRead: false,
    isLoadingWrite: false,
    showHeader: false
  },
  modals: {
    customModal: {
      show: false,
      title: '',
      body: '',
      showCloseButton: false,
      size: '',
      okLabel: '',
      cancelLabel: '',
      closeOnOk: true
    }
  },
  login: {
    member: null,
    username: null,
    password: null,
    loggedin: false,
    isLoggingin: false,
    isTermsAccepted: false,
    logginError: null,
    deviceToken: null,
    deviceType: null,
    appVersion: null
  },
  bottomnav: {
    items: NAVIGATION_LIST,
    activeItem: NAVIGATION_LIST[0].name
  },
  referrals: {
    currentDetailCard: null
  }
};

export const ERROR_MESSAGE = 'An Error Occurred';

export const REASSIGNED_MESSAGE = 'This lead has been re-assigned';

export const LINKING_SERVICE = {
  NOTIFICATION_DATA: 'NOTIFICATION_DATA',
  DEVICE_TOKEN: 'DEVICE_TOKEN',
  SET_BADGE_NUMBER: 'SET_BADGE_NUMBER',
  ADDED_LISTENER: 'ADDED_LISTENER',
  GO_BACK: 'GO_BACK',
  OPEN_PLAY_STORE: 'OPEN_PLAY_STORE'
};

export const DEVICE_TYPE = {
  IOS: 2,
  ANDROID: 3
};
export const STATE_CODES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

export const REMAINDER_EMAIL_MINUTES = [
  [-1, 'No Reminder'],
  [5, '5 mins before'],
  [30, '30 mins before'],
  [60, '1 hour before'],
  [1440, '1 day before'],
  [2880, '2 days before'],
  [4320, '3 days before']
];

export const REMAINDER_PUSH_NOTIFICATION_MINUTES = [
  [-1, 'No Reminder'],
  [0, 'at time of task'],
  [5, '5 minutes before'],
  [10, '10 minutes before'],
  [15, '15 minutes before'],
  [30, '30 minutes before'],
  [60, '1 hour before'],
  [120, '2 hours before'],
  [240, '4 hours before'],
  [360, '6 hours before'],
  [720, '12 hours before'],
  [1440, '1 day before'],
  [2880, '2 days before'],
  [10080, '1 week before']
];

export const OPPORTUNITY_STATUSES = {
  BUYER_STATUSES_BEFORE_UNDER_CONTRACT: ['Pending Lender Pre-approval', 'Customer Undecided', 'Actively Shopping', 'Customer Not Moving Forward'],
  BUYER_STATUSES_AFTER_UNDER_CONTRACT: ['Customer Not Ready To Transact In 3 Months', 'Customer Not Moving Forward'],
  SELLER_STATUSES_BEFORE_PRE_LIST: ['Customer Undecided', 'Customer Intends to List', 'Customer Not Moving Forward'],
  SELLER_STATUSES_AFTER_PRE_LIST: ['Customer Not Ready To Transact In 3 Months', 'Customer Not Moving Forward'],
  BUYER_STATUSES_NURTURE: ['Actively Shopping'],
  SELLER_STATUSES_NURTURE: ['Customer Intends to List'],
  BUYER_STATUSES_FALLOUT: ['Actively Shopping'],
  SELLER_STATUSES_FALLOUT: ['Customer Intends to List'],
  SELLER_STATUS_CONTINGENT_ON_SALE: ['Actively Shopping', 'Customer Not Ready To Transact In 3 Months', 'Customer Not Moving Forward']
};

export const EXCLUDE_FROM_AGENT = ['Under Contract', 'Agent Assignment', 'Agent Reassignment', 'Concierge Attempting Initial Contact', 'Pre List', 'Pre Auction'];

export const OPPORTUNITY_STATUS_DESCRIPTION = {
  CUSTOMER_UNDECIDED: 'The customer is reviewing and/or considering all options before making a decision to move forward with the assigned Xome Agent.',
  ACTIVELY_SHOPPING: 'The customer has decided to move forward with the agent and has agreed to start actively searching for a property with the agent\'s assistance.',
  CUSTOMER_NOT_MOVING_FORWARD: 'After the agent\'s  initial customer appointment, the customer has decided not to move forward with the agent.',
  CUSTOMER_NOT_READY_TO_TRANSACT_IN_3MONTHS: 'The customer has paused the buying/selling process. Customer has agreed to a follow-up call, text and/or email from the agent and/or Xome within 90 days or more.',
  CUSTOMER_INTENDS_TO_LIST: 'The customer has decided to move forward with the agent and is reviewing the listing documents to execute and to get the property on the market.',
  ON_HOLD_CUSTOMER_INTENT: 'The customer has paused the buying/selling process. Customer has agreed to a follow-up call, text and/or email from the agent and/or ARM within 90 days or less.',
  PENDING_APPOINTMENT: 'The initial customer appointment is confirmed between agent and customer, but has not taken place.',
  TOURING_PROPERTIES: 'The agent has secured a buyer\'s representation agreement. Customer has agreed to a touring appointment with the agent or is actively touring properties with the agent\'s assistance.',
  PRE_LIST: 'Xome has received a copy of the signed listing agreement. Waiting for MLS sheet or additional documents in order to move to Listed/PreAuction status.',
  LISTED: 'Property is listed with agent. Xome has received signed listing agreement, Xome documents, and MLS sheet from agent.',
  PENDING_LENDER_PRE_APPROVAL: 'The customer is pending loan approval from the lender.'
};

export const EXCLUDE_DISPOSITION_BUY_STATUSES = [
  'Actively Shopping',
  'Touring Properties',
  'Pending Contract',
  'Closed',
  'Under Contract'
];
export const EXCLUDE_DISPOSITION_SELL_STATUSES = [
  'Pre List',
  'Listed',
  'Pending Contract',
  'Pre Auction',
  'Under Contract',
  'Closed'
];
